import Button from '@material-ui/core/Button'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { dateFromCalendar, formatDate } from '../../lib/formatDateHandler'
import * as actions from '../../store/actions'
import DataSporzadzeniaStyle from '../../styles/DataSporzadzeniaStyle'
import CustomDatePicker from '../controls/CustomDatePicker'
import OkresSprawozdaniaStyle from '../../styles/OkresSprawozdaniaStyle'

const DataSporzadzenia = ({
  onGetStructures,
  onSetDataSporzadzenia,
  onSetOkresSprawozdania,
  onSetCzyWyborDaty,
  onUploadZipFile,
  paczkaZip,
  dataSporzadzenia,
  poczatekOkresu,
  koniecOkresu,
}) => {
  const [data, setData] = useState(Date.now())
  const [dateFrom, setDateFrom] = useState(new Date(new Date().getFullYear()-1, 0, 1).valueOf())
  const [dateTo, setDateTo] = useState(new Date(new Date().getFullYear()-1, 11, 31).valueOf())

  useEffect(() => {
    if (dataSporzadzenia) setData(dataSporzadzenia)
    if (poczatekOkresu) setDateFrom(poczatekOkresu)
    if (koniecOkresu) setDateTo(koniecOkresu)
  }, [])

  const zatwierdz = () => {
    const fData = formatDate(dateFromCalendar(data))
    onSetDataSporzadzenia(fData)
    const fDataOd = formatDate(dateFromCalendar(dateFrom))
    const fDataDo = formatDate(dateFromCalendar(dateTo))
    onSetOkresSprawozdania(fDataOd, fDataDo)
    onSetCzyWyborDaty(false)
    if (!paczkaZip) onGetStructures(fData, fDataOd, fDataDo)
    else onUploadZipFile(paczkaZip, fData, fDataOd, fDataDo)
  }

  return (
    <DataSporzadzeniaStyle>
      <div className="header">
        <span className="high-headline-5">OKRES OBJĘTY SPRAWOZDANIEM FINANSOWYM I DATA SPORZĄDZENIA</span>
        <Button
          onClick={() => onSetCzyWyborDaty(false)}
          variant="outlined"
          color="primary"
        >
          WRÓĆ NA POCZĄTEK
        </Button>
      </div>
      <div className="window">
        <span className="medium-headline-5">
          Potwierdź lub zmień daty
        </span>
        <OkresSprawozdaniaStyle>
          <div className='firstRow'>
              <CustomDatePicker
              name="DateFrom"
              minDate={new Date(1995, 0, 1)}
              maxDate={new Date(2099, 11, 31)}
              label="Początek okresu"
              value={dateFrom}
              onChange={e => setDateFrom(e)}
            />
            <p className='separator'>-</p>
            <CustomDatePicker
              name="DateTo"
              minDate={new Date(1995, 0, 1)}
              maxDate={new Date(2099, 11, 31)}
              label="Koniec okresu"
              value={dateTo}
              onChange={e => setDateTo(e)}
              />        
          </div>
          <div className='secondRow'>
            <CustomDatePicker
            name="DataSporzadzenia"
            minDate={new Date(1995, 0, 1)}
            maxDate={new Date(2099, 11, 31)}
            label="Data sporządzenia"
            value={data}
            onChange={e => setData(e)}
            />
          </div>
        </OkresSprawozdaniaStyle>        
        <Button
          onClick={zatwierdz}
          variant="contained"
          color="primary"
          className="check"
          disabled={!data}
        >
          ZATWIERDŹ
        </Button>
      </div>
      <div className="footer">
        <span className="medium-headline-5">Dlaczego to takie ważne?</span>
        <p className="disabled-subtitle-2">
          Struktury logiczne używane do zapisu i elektronicznej wysyłki
          sprawozdań finasowych są okresowo zmieniane i mają już kilka wersji.
          To właśnie na podstawie tych dat decydujemy o tym, którego
          formatu należy użyć do zapisu Twojego sprawozdania.
        </p>
        <p className="disabled-subtitle-2">
          Prosimy, zastanów się nad wyborem tych dat. Po utworzeniu pliku XML z
          e-Sprawozdaniem ich późniejsza modyfikacja może być możliwa tylko w
          ograniczonym zakresie - takim, który nie spowoduje potrzeby zmiany
          formatu pliku.{' '}
        </p>
      </div>
    </DataSporzadzeniaStyle>
  )
}

const mapStateToProps = state => {
  return {
    paczkaZip: state.sprawozdanie.paczkaZip,
    dataSporzadzenia: state.sprawozdanie.dataSporzadzenia,
    poczatekOkresu: state.sprawozdanie.poczatekOkresu,
    koniecOkresu: state.sprawozdanie.koniecOkresu,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetDataSporzadzenia: data => dispatch(actions.setDataSporzadzenia(data)),
    onSetOkresSprawozdania: (dataOd, dataDo) => dispatch(actions.setOkresSprawozdania(dataOd, dataDo)),
    onSetCzyWyborDaty: v => dispatch(actions.setCzyWyborDaty(v)),
    onGetStructures: (data, dataOd, dataDo) => dispatch(actions.getAvailableStructures(data, dataOd, dataDo)),
    onUploadZipFile: (paczka, data, dateFrom, dateTo) =>
      dispatch(actions.uploadZipFile(paczka, data, dateFrom, dateTo)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataSporzadzenia)
